import { createSelector } from 'reselect';

import { AppState } from '../../store/store';
import { WhishListState } from './whish-list-reducer';
import { currencySelector, localesSelector, userSelector } from './configuration-selectors';
import { mapWishList } from '../models/mapper/wish-list-mapper';

const wishListState = (state: AppState): WhishListState => state.whishList;

export const wishListsSelector = createSelector([userSelector, wishListState], (user, state) => {
    const lists = [...state.wishLists];
    // Move default wish list to start of array
    const defaultListIndex = lists.findIndex(x => x.isDefault);

    if (defaultListIndex > 0) {
        lists.unshift(lists.splice(defaultListIndex, 1)[0]);
    }

    return lists.map(list => ({ ...list, isOwner: list.owner?.id === user?.contact.id }));
});

export const wishListDetailSelector = createSelector(
    currencySelector,
    localesSelector,
    userSelector,
    wishListsSelector,
    wishListState,
    (currency, locales, user, wishLists, state) =>
        state.details ? mapWishList(state.details, locales, currency, wishLists, user?.contact.id) : null
);
